import { render, staticRenderFns } from "./TIconButton.vue?vue&type=template&id=6356b2a0&scoped=true&"
import script from "./TIconButton.vue?vue&type=script&lang=js&"
export * from "./TIconButton.vue?vue&type=script&lang=js&"
import style0 from "./TIconButton.vue?vue&type=style&index=0&id=6356b2a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6356b2a0",
  null
  
)

/* custom blocks */
import block0 from "./TIconButton.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports